import React, { memo } from 'react';

const PageHeader = (props) => <h1 className="page-header">{props.title}</h1>;

export default memo(PageHeader);
